export enum DiscountCodeScope {
  Tickets = 'Tickets',
  Kiosk = 'Kiosk',
  Both = 'Both'
}
